
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/antiviruschoice/privacy-policy",
      function () {
        return require("private-next-pages/antiviruschoice/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/antiviruschoice/privacy-policy"])
      });
    }
  